import { useEffect } from 'react'
import { setLanguageInitial } from './language'
import { useSearchParams } from 'react-router-dom'
import { Language } from '@/enums/language'

export const useInitiateLanguage = () => {
  useEffect(() => {
    setLanguageInitial()
  }, [])
}

export const useGetLanguageQueryParam = () => {
  const [params] = useSearchParams()
  return params.get(Language.QUERY_PARAM)
}

export const useSetLanguageQueryParam = language => {
  const [, setSearchParams] = useSearchParams({})
  setSearchParams({ [Language.QUERY_PARAM]: language })
}

export const useInEnglish = () => {
  const language = useGetLanguageQueryParam()
  return language !== Language.SPANISH_ABBR
}

export const useInSpanish = () => {
  const language = useGetLanguageQueryParam()
  return language === Language.SPANISH_ABBR
}
